const URL_BASE = '/';
const URL_CREATE_TOKEN = 'auth/create_session/create_chat_token';
const URL_ASK = 'answer_question_dopamine';
const URL_USER_VALIDATION = 'web_chat/user_validation';
const URL_VALIDATE_USER_EVENTS_MERGE = 'auth/validate_user_events_merge';
const URL_HANDLE_EXTERNAL_USER_PROCESS = 'handle_external_user_process';

export default URL_BASE;
export {
  URL_ASK,
  URL_CREATE_TOKEN,
  URL_USER_VALIDATION,
  URL_VALIDATE_USER_EVENTS_MERGE,
  URL_HANDLE_EXTERNAL_USER_PROCESS,
};
